import { useEffect, useState } from "react";
import { Megaphone, ExternalLink } from "lucide-react";
import api from "@/lib/api";

/** Pinned coach announcement shown at the top of the student dashboard. */
export const AnnouncementBanner = () => {
  const [a, setA] = useState(null);

  useEffect(() => {
    api.get("/announcements/active").then(({ data }) => {
      if (data && data.id) setA(data);
    }).catch(() => {});
  }, []);

  if (!a) return null;

  return (
    <div
      className="surface-card p-5 mb-8 flex items-start gap-4"
      style={{ borderColor: "var(--lime)", background: "var(--lime-glow)" }}
      data-testid="announcement-banner"
    >
      <div
        className="w-10 h-10 rounded-2xl flex items-center justify-center shrink-0"
        style={{ background: "var(--surface)", color: "var(--lime)" }}
      >
        <Megaphone size={18} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="font-mono text-[11px] uppercase tracking-wider mb-1" style={{ color: "var(--lime)" }}>
          Announcement
        </div>
        <div className="font-semibold text-base mb-1" data-testid="announcement-title">{a.title}</div>
        <p className="text-sm whitespace-pre-line" style={{ color: "var(--text-muted)" }} data-testid="announcement-body">
          {a.body}
        </p>
        {a.link && (
          <a
            href={a.link}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-sm font-semibold mt-3 transition hover:opacity-80"
            style={{ color: "var(--lime)" }}
            data-testid="announcement-link"
          >
            {a.link_label || "Open link"} <ExternalLink size={13} />
          </a>
        )}
      </div>
    </div>
  );
};

export default AnnouncementBanner;
